import i18n, { DEFAULT_LANGUAGE } from "../../i18next"

export const CodeTable = {
  damageCaseDefaultTexts: "damageCaseDefaultTexts",
  unitTypes: "unitTypes",
  trades: "trades",
}

export const getCodeTableEntries = (state, codeTableName) => {
  const codeTable = state.common && state.common.codeTables && state.common.codeTables[codeTableName]
  return codeTable && codeTable.entries
}

export const getCodeTableAttribute = (codeTableEntries, code, attribute) => {
  const entry = codeTableEntries && codeTableEntries.find(entry => entry.code === code)
  const attrTranslated = `${attribute}${capitalize(i18n.language || DEFAULT_LANGUAGE)}`
  const attrDe = `${attribute}De`
  return (entry && (entry[attrTranslated] || entry[attrDe])) || null
}

const capitalize = string => {
  return string[0].toUpperCase() + string.slice(1)
}



// WEBPACK FOOTER //
// ./src/features/common/codeTableAccess.js